import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import UsersChart from "./user-chart";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { UserStatisticResponse } from "src/_pages/admin/interfaces/user-statical-interface";
import UserService from "src/_cores/_services/user.service";

const UsersStatistical = () => {
  const [data, setData] = useState<UserStatisticResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const today = dayjs();
  const thirtyDaysAgo = today.subtract(30, "day");
  const [params, setParams] = useState<{
    fromDate: Dayjs | null;
    toDate: Dayjs | null;
  }>({
    fromDate: thirtyDaysAgo,
    toDate: today,
  });

  const fetchStatistic = async () => {
    if (!params.fromDate || !params.toDate) return;
    setLoading(true);
    try {
      const res = await UserService.getUserStatistic(
        params.fromDate.format("YYYY-MM-DD"),
        params.toDate.format("YYYY-MM-DD")
      ) as any;
      setData(res);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatistic();
  }, []);

  const onChangeDate = (type: "fromDate" | "toDate", date: Dayjs | null) => {
    setParams({ ...params, [type]: date });
  };

  return (
    <div>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Người dùng
      </Typography>
      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Từ ngày"
              value={params.fromDate}
              onChange={(newValue) => onChangeDate("fromDate", newValue)}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Đến ngày"
              value={params.toDate}
              onChange={(newValue) => onChangeDate("toDate", newValue)}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "center" }}>
          <Button variant="contained" onClick={fetchStatistic}>Xem</Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid item xs={12} sm={12}>
          <UsersChart data={data} loading={loading} />
        </Grid>
      </Grid>
    </div>
  );
};

export default UsersStatistical;
